import React from 'react';
import ArticleCard from '../components/ArticleCard';
import SectionHeader from '../components/SectionHeader';
import { Article } from 'home/types/types';
import he from 'he';

interface EditorPicksProps {
  articles: Article[];
}

const EditorPicks: React.FC<EditorPicksProps> = ({ articles }) => {
  const featuredArticle = window.editorsChoiceData.articles ? window.editorsChoiceData.articles[0] : null;
  const otherArticles = window.editorsChoiceData.articles ? window.editorsChoiceData.articles.slice(1) : [];
  const sectionTitle = window.editorsChoiceData.sectionTitle;
  const hasTitleLink = window.editorsChoiceData.hasTitleLink;
  const sectionLinkText = window.editorsChoiceData.sectionLinkText;
  const sectionUrl = window.editorsChoiceData.sectionUrl;
  const showIcon = window.editorsChoiceData.showIcon;
  const iconUrl = window.editorsChoiceData.iconUrl;
  const linkIcon = window.editorsChoiceData.linkIcon;
  const hideHeader = window.editorsChoiceData.hideHeader;

  const bgStyle = {
    backgroundImage: `url(${he.encode(featuredArticle?.imageLink ?? '')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  };

  const gradientStyle = {
    background:
      'linear-gradient(180deg, rgba(2, 6, 23, 0) 0%, rgba(2, 6, 23, 0.4) 100%), radial-gradient(50% 50% at 50% 50%, rgba(2, 6, 23, 0) 0%, #020617 100%)',
  };

  const isExternal = linkIcon === 'external';

  return (
    <div className="react-block__editors-picks">
      <div className="container">
        {featuredArticle && (
          <div className="react-block__editors-picks-featured" style={bgStyle}>
            <div className="react-block__editors-picks-featured-gradient" style={gradientStyle}>
              <div className="react-block__editors-picks-featured-flex">
                <SectionHeader
                  title={sectionTitle}
                  linkLabel={sectionLinkText}
                  url={sectionUrl}
                  hasPreIcon={showIcon}
                  isExternal={isExternal}
                  iconUrl={iconUrl}
                  hasTitleLink={hasTitleLink}
                  hideHeader={hideHeader}
                />
                <ArticleCard article={featuredArticle} cardType={3} />
              </div>
            </div>
          </div>
        )}

        <div className="react-block__card-container react-block__card-container--border">
          {otherArticles.map((article, index) => (
            <ArticleCard key={index} article={article} cardType={'one-third'} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EditorPicks;
